/* Shop the look section: dots placed on the pieces, and the panel on phones. */
(() => {
  /* ---------- Shop the look section ---------- */
  function placeDots(section) {
    const stage = section.querySelector('[data-look-stage]');
    const media = section.querySelector('[data-look-media]');
    if (!stage) return;
    const W = stage.clientWidth, H = stage.clientHeight;
    let w = 0, h = 0;
    if (media) { w = media.naturalWidth || media.videoWidth || 0; h = media.naturalHeight || media.videoHeight || 0; }
    if (!w || !h) {
      const poster = section.querySelector('.showcase__poster');
      if (poster) { w = poster.naturalWidth; h = poster.naturalHeight; }
    }
    section.querySelectorAll('[data-look-dot]').forEach((dot) => {
      const x = parseFloat(dot.dataset.x) / 100, y = parseFloat(dot.dataset.y) / 100;
      let left = x * W, top = y * H;
      if (w && h && W && H) {
        // The photo is cropped to fill the panel; keep each dot on its piece
        const s = Math.max(W / w, H / h);
        left = (W - w * s) / 2 + x * w * s;
        top = (H - h * s) / 2 + y * h * s;
      }
      const inside = left > 14 && left < W - 14 && top > 14 && top < H - 14;
      dot.style.left = `${left}px`;
      dot.style.top = `${top}px`;
      dot.hidden = !inside;
      dot.classList.toggle('look__dot--flip', left > W * 0.6);
    });
  }

  function setup(section) {
    if (!section || section.dataset.lookReady) return;
    section.dataset.lookReady = '1';
    const id = section.dataset.drawerId;
    // The panel lives on the page itself so it sits above the header
    const drawer = section.querySelector('[data-look-drawer]');
    document.querySelectorAll(`[id="${id}"]`).forEach((el) => { if (el !== drawer) el.remove(); });
    if (drawer) document.body.appendChild(drawer);

    let last = null;
    const open = (index) => {
      if (!drawer) return;
      last = document.activeElement;
      drawer.classList.add('is-open');
      drawer.removeAttribute('aria-hidden');
      document.body.style.overflow = 'hidden';
      const rows = drawer.querySelectorAll('[data-look-item]');
      const row = index != null ? rows[index] : null;
      const close = drawer.querySelector('[data-look-close].icon-btn');
      if (close) close.focus({ preventScroll: true });
      if (row) {
        row.scrollIntoView({ block: 'nearest' });
        row.classList.remove('is-flash'); void row.offsetWidth; row.classList.add('is-flash');
      }
    };
    const close = () => {
      if (!drawer || !drawer.classList.contains('is-open')) return;
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      if (last && last.focus) last.focus({ preventScroll: true });
    };
    if (drawer) {
      drawer.querySelectorAll('[data-look-close]').forEach((b) => b.addEventListener('click', close));
      drawer.addEventListener('keydown', (e) => {
        if (e.key === 'Escape') close();
        if (e.key !== 'Tab') return;
        const nodes = Array.from(drawer.querySelectorAll('a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"])')).filter((n) => n.offsetParent !== null);
        if (!nodes.length) return;
        const first = nodes[0], lastNode = nodes[nodes.length - 1];
        if (e.shiftKey && document.activeElement === first) { e.preventDefault(); lastNode.focus(); }
        else if (!e.shiftKey && document.activeElement === lastNode) { e.preventDefault(); first.focus(); }
      });
      const wide = window.matchMedia('(min-width: 990px)');
      const onWide = () => { if (wide.matches) close(); };
      if (wide.addEventListener) wide.addEventListener('change', onWide); else if (wide.addListener) wide.addListener(onWide);
      drawer.addEventListener('look:added', close);
    }

    const aside = section.querySelector('[data-look-aside]');
    const sideShown = () => aside && aside.offsetParent !== null;
    section.addEventListener('click', (e) => {
      const dot = e.target.closest('[data-look-dot]');
      if (sideShown()) {
        // Computers: the pieces are already beside the photo
        if (!dot) return;
        const row = aside.querySelectorAll('[data-look-item]')[parseInt(dot.dataset.lookDot, 10)];
        if (row) { row.scrollIntoView({ block: 'nearest', behavior: 'smooth' }); row.classList.remove('is-flash'); void row.offsetWidth; row.classList.add('is-flash'); }
        return;
      }
      if (dot) { e.preventDefault(); open(parseInt(dot.dataset.lookDot, 10)); return; }
      if (e.target.closest('[data-look-open]') || e.target.closest('[data-look-stage]')) open(null);
    });

    const media = section.querySelector('[data-look-media]');
    const place = () => placeDots(section);
    if (media) { media.addEventListener('load', place); media.addEventListener('loadedmetadata', place); }
    const poster = section.querySelector('.showcase__poster');
    if (poster) poster.addEventListener('load', place);
    if ('ResizeObserver' in window) new ResizeObserver(place).observe(section.querySelector('[data-look-stage]'));
    window.addEventListener('resize', place, { passive: true });
    place();
  }

  const all = () => document.querySelectorAll('[data-look]').forEach(setup);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', all);
  else all();
  document.addEventListener('shopify:section:load', (e) => {
    const s = e.target.querySelector('[data-look]');
    if (s) setup(s);
    e.target.querySelectorAll('look-buy').forEach((el) => el.connectedCallback());
  });
  document.addEventListener('shopify:section:unload', (e) => {
    const s = e.target.querySelector('[data-look]');
    if (s) { const d = document.getElementById(s.dataset.drawerId); if (d) { if (d.classList.contains('is-open')) document.body.style.overflow = ''; d.remove(); } }
  });
})();
